var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestorDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 42.125L24.125 33.625L32.625 42.125H15.625Z",
    fill: "url(#paint0_linear_597_13549)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4287 6H7.42871V31.5C7.42871 32.0636 7.65259 32.6041 8.05111 33.0026C8.44962 33.4011 8.99013 33.625 9.55371 33.625H39.3037C39.8673 33.625 40.4078 33.4011 40.8063 33.0026C41.2048 32.6041 41.4287 32.0636 41.4287 31.5V6ZM34.5478 14.5C34.5478 13.6058 33.8229 12.881 32.9287 12.881C32.0345 12.881 31.3097 13.6058 31.3097 14.5V25.125C31.3097 26.0192 32.0345 26.744 32.9287 26.744C33.8229 26.744 34.5478 26.0192 34.5478 25.125V14.5ZM26.0478 18.75C26.0478 17.8558 25.3229 17.131 24.4287 17.131C23.5345 17.131 22.8097 17.8558 22.8097 18.75V25.125C22.8097 26.0192 23.5345 26.744 24.4287 26.744C25.3229 26.744 26.0478 26.0192 26.0478 25.125V18.75ZM17.5478 23C17.5478 22.1058 16.8229 21.381 15.9287 21.381C15.0345 21.381 14.3097 22.1058 14.3097 23V25.125C14.3097 26.0192 15.0345 26.744 15.9287 26.744C16.8229 26.744 17.5478 26.0192 17.5478 25.125V23Z",
    fill: "#BE97FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_597_13549",
    x1: 27.797,
    y1: 6.86883,
    x2: 18.3325,
    y2: 40.4496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestorDashboard);
export default __webpack_public_path__ + "static/media/investor-dashboard.489bfd2aeebc24dcc12b18715e8d01f6.svg";
export { ForwardRef as ReactComponent };